import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { BackendStatusService } from '../../services/backend-status/backend-status.service';
import { UnderConstructionComponent } from '../../pages/under-construction/under-construction.component';

@Component({
  selector: 'app-layout',
  imports: [RouterOutlet, UnderConstructionComponent, TranslateModule],
  templateUrl: './app.layout.component.html',
  styleUrl: './app.layout.component.scss'
})
export class AppLayoutComponent implements OnInit {
  constructor(protected readonly backendStatusService: BackendStatusService) {}

  ngOnInit(): void {
    this.backendStatusService.checkBackendReachability();
  }

  protected get isCheckingBackend(): boolean {
    return this.backendStatusService.status() === 'checking';
  }

  protected get isBackendReachable(): boolean {
    return this.backendStatusService.status() === 'reachable';
  }
}
